// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2FqGs","emails":"CreateEditClinics_emails__3FrVa","emailTagLabel":"CreateEditClinics_emailTagLabel__3M6so"};